export default {"src":"/_next/static/media/menu-share-active-icon.97d38cbc.svg","height":14,"width":14};